// resources/js/Components/TranslationContext
import React, { createContext, useContext, ReactNode } from "react";

interface TranslationContextType {
    Lang: (key: string, replacements?: Record<string, any>, forceString?: boolean) => any;
}

const TranslationContext = createContext<TranslationContextType | null>(null);

export const TranslationProvider = ({ children, translations }: { children: ReactNode; translations: Record<string, string> }) => {
    // translations - это объект с переводами, который мы передали из Laravel
    const Lang = (key, replacements = {}, forceString = true) => {
        // Источник данных для перевода - 'translations' из пропсов Inertia

        let translation = translations[key];

        // Если перевод не найден, возвращаем ключ
        if (
            typeof translation === "undefined" ||
            String(translation) === "undefined"
        ) {
            return key;
        }

        // Приводим к строке и разбиваем строку для вставки элементов
        translation = String(translation ?? "");
        let parts = translation.split(/(:\w+)/g);

        const mapped = parts.map((part, i) => {
            if (part.startsWith(":")) {
                let k = part.slice(1);
                // forceString: просто строка, иначе React.Fragment
                return forceString ? (
                    replacements[k] !== undefined ? (
                        String(replacements[k])
                    ) : (
                        part
                    )
                ) : (
                    <React.Fragment key={i}>
                        {replacements[k] ?? part}
                    </React.Fragment>
                );
            }
            return part;
        });

        if (forceString) {
            return mapped.join("");
        }
        return mapped;
    };

    return (
        <TranslationContext.Provider value={{ Lang }}>
            {children}
        </TranslationContext.Provider>
    );
};

export const useTranslation = (): TranslationContextType => {
    const ctx = useContext(TranslationContext);
    if (!ctx) {
        // Возвращаем безопасную заглушку, чтобы не падало приложение
        return { Lang: () => "" };
    }
    return ctx;
};
